export default "__VITE_ASSET__DDPil$R2__"